import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedLayer: null,
};

// Create a slice for auth state with a name, initial state, and reducers
const selectedLayerSlice = createSlice({
  name: "selectedLayer",
  initialState,
  reducers: {
    updateSelectedLayer: (state, action) => {
      state.selectedLayer = action.payload;
    },
  },
});

// Export the generated action creators and the reducer
export const { updateSelectedLayer } = selectedLayerSlice.actions;
export const selectedLayerReducer = selectedLayerSlice.reducer;
